<div class="subtable-grid-container">
  <div class="subtable-header subtable-grid-common" appCalcSubtableColumnWidth>
    @for (header of headers; track header.label + '-' + $index) {
      <div class="subtable-header-cell">
        <sh-text color="secondary">{{ header.label | translate }}</sh-text>
      </div>
    }
  </div>
  @for (row of rows; track row + '-' + $index) {
    <div class="subtable-row subtable-grid-common" appCalcSubtableColumnWidth>
      @for (cell of headers; track $index) {
        @switch (cell.key) {
          @case ('consumedDate') {
            <div class="subtable-row-cell">
              <sh-text>{{ row[cell.key] | localizedDate }}</sh-text>
            </div>
          }
          @case ('partNumber') {
            <div class="subtable-row-cell part-number">
              <sh-text>{{ row[cell.key] }}</sh-text>
              <sh-icon
                color="#7D7D7D"
                icon="copy-results-to-clipboard"
                aria-label="{{
                  'spareParts.ariaLabel.copyClipboard' | translate
                }}"
                size="s"
                button
                (click)="clipboardService.copyToClipboard(row[cell.key])"
                (keydown.enter)="
                  clipboardService.copyToClipboard(row[cell.key])
                "
                (keydown.space)="
                  clipboardService.copyToClipboard(row[cell.key])
                "
              ></sh-icon>
            </div>
          }
          @default {
            <div class="subtable-row-cell">
              <sh-text>{{ row[cell.key] }}</sh-text>
            </div>
          }
        }
      }
    </div>
    <sh-divider spacing="none"></sh-divider>
  }
</div>
